import React, {Component} from 'react';
import {connect} from 'react-redux';
import {API_URL} from "../../config/Config";
import validator from "validator";
import axios from "axios/index";
import {LangValidation} from "../../lang/fa/validation";
import {Row, Col, Alert, Button} from "reactstrap";
import { ToastContainer, toast } from 'react-toastify';
import PageLoader from "../loader/PageLoader";

class ChangePassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            activeItemPills: '1',
            fields: {
              old_password:"",
              password:"",
              re_password:"",
            },
            errors: {},
            hasAlert:false,
        };

    }

    handleValidation(callback) {
        let {fields} = this.state;
        let errors = {};
        let formIsValid = true;

        if (validator.isEmpty(fields.old_password)) {
            formIsValid = false;
            errors["old_password"] = LangValidation.required;
        }else if (!validator.isLength(fields.old_password, {min: 6, max: undefined})) {
            formIsValid = false;
            errors["old_password"] = LangValidation.min;
        }

        if (validator.isEmpty(fields.password)) {
            formIsValid = false;
            errors["password"] = LangValidation.required;
        }else if (!validator.isLength(fields.password, {min: 6, max: undefined})) {
            formIsValid = false;
            errors["password"] = LangValidation.min;
        }

        if (validator.isEmpty(fields.re_password)) {
            formIsValid = false;
            errors["re_password"] = LangValidation.required;
        }else if (fields.re_password !== fields.password) {
            formIsValid = false;
            errors["re_password"] = LangValidation.same;
        }

        this.setState({errors}, () => {
            return callback(formIsValid)
        });

    }

    handleChange(event) {
        let fields = this.state.fields;
        let errors = {};
        let target = event.target;
        fields[target.name] = target.value;

        switch (target.name) {
            case 'old_password':
                if (validator.isEmpty(fields.old_password)) {
                    errors["old_password"] = LangValidation.required;
                }else if (!validator.isLength(fields.old_password, {min: 6, max: undefined})) {
                    errors["old_password"] = LangValidation.min;
                }
                break;
            case 'password':
                if (validator.isEmpty(fields.password)) {
                    errors["password"] = LangValidation.required;
                }else if (!validator.isLength(fields.password, {min: 6, max: undefined})) {
                    errors["password"] = LangValidation.min;
                }
                break;
            case 're_password':
                if (validator.isEmpty(fields.re_password)) {
                    errors["re_password"] = LangValidation.required;
                }else if (fields.re_password !== fields.password) {
                    errors["re_password"] = LangValidation.same;
                }
                break;
            default:
        }
        this.setState({
            fields,errors
        });

    }

    static checkStatus(response) {
        if (response.status < 200 || response.status > 300) {
            const error = new Error(response.statusText);
            error.response = response;
            throw error;
        }
        return response.data;
    }

    handleRequest() {
        const {old_password, password} = this.state.fields;
        const data = {old_password, new_password: password};
        let errors = {};
        this.setState({loading:false});
        axios.post(`${API_URL}user-changepassword?api_token=${this.props.user.apiToken}`, data)
            .then(
                this.checkStatus
            ).then(json => {
            // this.props.setUser(json.data);
            toast.success("اطلاعات با موفقیت ذخیره گردید.",{
                autoClose: 3000,
                position: toast.POSITION.TOP_RIGHT,
                rtl:true
            });
            this.setState({loading:true,hasAlert:false});
        })
            .catch(error => {
                this.setState({loading:true});
                const response = error.response;
                if (response === undefined) {
                    toast.error("خطایی در هنگام ذخیره سازی اطلاعات رخ داد.",{
                        autoClose: 3000,
                        position: toast.POSITION.TOP_RIGHT,
                        rtl:true
                    });
                    console.log(error);
                } else {
                    // console.log(response.data);
                    toast.error(response.data.data,{
                        autoClose: 3000,
                        position: toast.POSITION.TOP_RIGHT,
                        rtl:true
                    });
                }

                this.setState({hasAlert:true, errors,loading:true});
            });

    }

    handleSubmit(event) {
        event.preventDefault();
        this.handleValidation((valid) => {
            if (valid) this.handleRequest();
        });
    }

    render() {
        const {old_password, password, re_password} = this.state.fields;
        const {errors, loading} = this.state;


        return (
            <div className="pt-3">
                <Row>
                    <Col md="12">
                        {this.state.hasAlert?
                            <Alert color="danger">
                                خطایی در هنگام ثبت اطلاعات رخ داد.
                            </Alert>
                            :""}
                    </Col>
                </Row>
                {!loading ? <PageLoader type="bubbles" color="#4fbfa8"/>:
                    <form>
                        <Row>
                            <Col md="3" sm="12"/>
                            <Col md="6" sm="12">
                                <div className="md-form input-group" error="true" >
                                    <span className="input-group-addon p-2">
                                        <i className="fa fa-key grey-text mt-3" style={{fontSize: 20}}/>
                                    </span>
                                    <input
                                        type="password"
                                        className={errors["old_password"]?"form-control is-invalid":"form-control"}
                                        placeholder="رمز عبور جاری"
                                        autoComplete="off"
                                        name="old_password"
                                        value={old_password}
                                        onChange={this.handleChange.bind(this)}
                                    />
                                    {errors["old_password"]?<div className="invalid-feedback" >{errors["old_password"]}</div>:""}
                                </div>
                                <div className="md-form input-group">
                                    <span className="input-group-addon p-2">
                                        <i className="fa fa-key grey-text mt-3" style={{fontSize: 20}}/>
                                    </span>
                                    <input type="password"
                                           placeholder="رمز عبور جدید"
                                           className={errors["password"]?"form-control is-invalid":"form-control"}
                                           autoComplete="off"
                                           name="password"
                                           value={password}
                                           onChange={this.handleChange.bind(this)}
                                    />
                                    {errors["password"]?<div className="invalid-feedback" >{errors["password"]}</div>:""}
                                </div>
                                <div className="md-form input-group">
                                    <span className="input-group-addon p-2">
                                        <i className="fa fa-key grey-text mt-3" style={{fontSize: 20}}/>
                                    </span>
                                    <input type="password"
                                           placeholder="تکرار رمز عبور"
                                           className={errors["re_password"]?"form-control is-invalid":"form-control"}
                                           autoComplete="off"
                                           name="re_password"
                                           value={re_password}
                                           onChange={this.handleChange.bind(this)}/>
                                    {errors["re_password"]?<div className="invalid-feedback" >{errors["re_password"]}</div>:""}

                                </div>
                                <div className="text-center mt-5">
                                    <Button color="default" block onClick={this.handleSubmit.bind(this)} className="mb-4 mt-4">
                                        ثبت<i className="fa fa-paper-plane-o white-text ml-1"></i>
                                    </Button>
                                </div>



                            </Col>


                        </Row>
                    </form>}

                <ToastContainer
                    hideProgressBar={true}
                    newestOnTop={true}
                    autoClose={5000}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user,
    }
};

export default connect(mapStateToProps, null)(ChangePassword);



// WEBPACK FOOTER //
// ./src/components/user/ChangePassword.js